import firebase from "firebase/app";
import "firebase/auth";
import "firebase/storage";
import fc from "@/firebaseConfig";
import router from "@/router";
import getRoleList from "@/libs/getRoleList";

const _ = require("lodash");
const axios = require("axios");

export default {
  namespaced: true,
  state: {
    userData: { imageProfileUrl: "" },
    list: [],
    loading: false,
    userCompany: { isAdmin: false },
    userSearch: null,
    userProfile: {
      imageProfileUrl: "",
      nameFirstTH: "",
      nameLastTH: "",
      nameFirstEN: "",
      nameLastEN: "",
      companyName: "",
      email: "",
      imageProfileShow: "",
    },
    changePasswordStatus: "",
    uploadImgState: null,
    updateProfileStatus: null,
    updateDataStatus: null,
    pageLimitAutoChange: false,
    mUserListUnsubscribeObject: null,
    registerError: null,
    passwordDialog: false,
    passwordInput: "",
    profile: null,
    changeEmail: null,
  },
  mutations: {
    setUser(state, val) {
      state.userData = val;
    },
    setUserList(state, val) {
      state.list = val;
    },
    setLoading(state, val) {
      state.loading = val;
    },
    setUserCompany(state, val) {
      state.userCompany = val;
    },
    setUserSearch(state, val) {
      state.userSearch = val;
    },
    setUserProfile(state, val) {
      state.userProfile = val;
    },
    setChangePasswordStatus(state, val) {
      state.changePasswordStatus = val;
    },
    setUploadImgState(state, val) {
      state.uploadImgState = val;
    },
    setUpdateProfileStatus(state, val) {
      state.updateProfileStatus = val;
    },
    setUpdateDataStatus(state, val) {
      state.updateDataStatus = val;
    },
    setPageLimitAutoChange(state, val) {
      state.pageLimitAutoChange = val;
    },
    setRegisterError(state, val) {
      state.registerError = val;
    },
    setPasswordUpdateEmail(state, val) {
      state.password = val;
    },
    setPasswordDialog(state, val) {
      state.passwordDialog = val;
    },
    setProfileChangeEmail(state, val) {
      state.profile = val.profile;
      state.changeEmail = val.changeEmail;
    },
  },
  getters: {
    getProfile(state) {
      return state.profile;
    },
    getChangeEmail(state) {
      return state.changeEmail;
    },
    getPasswrod(state) {
      return state.password;
    },
  },
  actions: {
    get({ commit }) {
      let user = firebase.auth().currentUser;
      fc.users
        .doc(user.uid)
        .get()
        .then(function (user) {
          if (user.exists) {
            let userData = _.cloneDeep(user.data());
            commit("setUser", userData);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getPageLimit() {
      let user = firebase.auth().currentUser;
      fc.users
        .doc(user.uid)
        .get()
        .then(function (user) {
          localStorage.setItem("pageLimit", user.data().pageLimit || 10);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getList({ commit }, { companyId }) {
      if (this.state.mUserListUnsubscribeObject) {
        this.state.mUserListUnsubscribeObject();
      }
      this.state.mUserListUnsubscribeObject = fc.db
        .collection("CompaniesUsers")
        .where("companyID", "==", companyId)
        .onSnapshot((users) => {
          let usersArray = [];
          users.forEach((userData) => {
            let user = userData.data();
            user.id = userData.id;
            usersArray.push(user);
          });
          commit("setUserList", usersArray);
        });
    },
    getUserListUnsubscribe() {
      if (this.state.mUserListUnsubscribeObject) {
        this.state.mUserListUnsubscribeObject();
        this.state.mUserListUnsubscribeObject = null;
      }
    },
    getRoleUser({ commit }, { companyId }) {
      let user = firebase.auth().currentUser;
      fc.db
        .collection("CompaniesUsers")
        .doc(companyId + "_" + user.uid)
        .get()
        .then(function (user) {
          if (user.exists) {
            commit("setUserCompany", user.data());
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getUserProfile({ commit }) {
      let user = firebase.auth().currentUser;
      fc.users
        .doc(user.uid)
        .get()
        .then(function (user) {
          if (user.exists) {
            let userData = _.cloneDeep(user.data());
            commit("setUserProfile", userData);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    search({ commit }, { email }) {
      fc.users
        .where("email", "==", email)
        .get()
        .then(function (searchResult) {
          let userArray = [];
          if (searchResult.size > 0) {
            searchResult.forEach((user) => {
              userArray = user.data();
              userArray.id = user.id;
              commit("setUserSearch", userArray);
            });
          } else {
            commit("setUserSearch", null);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    register({ commit }, { registerData }) {
      firebase
        .auth()
        .createUserWithEmailAndPassword(
          registerData.email,
          registerData.password
        )
        .then((userCredential) => {
          const user = userCredential.user;
          this.dispatch("user/create", {
            user: user,
            registerData: registerData,
          });
        })
        .catch((err) => {
          this.error = err.message;
          commit("setRegisterError", err.message);
        });
      // fc.auth.onAuthStateChanged(user => {
      //   if (user) {
      //     console.log('user createeeeeeeee', user)
      //     this.dispatch('user/create', {user: user, registerData: registerData})
      //   }
      // })
    },
    setPasswordUpdateEmail({ commit }, val) {
      commit("setPasswordUpdateEmail", val);
    },
    validateCredentialUpdateEmail({ commit, dispatch, getters }) {
      var currentUser = firebase.auth().currentUser;
      var cred = firebase.auth.EmailAuthProvider.credential(
        currentUser.email,
        getters.getPasswrod
      );
      currentUser
        .reauthenticateWithCredential(cred)
        .then(() => {
          commit("setPasswordUpdateEmail", "");
          commit("setPasswordDialog", false);
          dispatch("updateUser", {
            profile: getters.getProfile,
            changeEmail: getters.getChangeEmail,
          });
        })
        .catch((e) => {
          alert(e.message);
        });
    },
    create(context, { user, registerData }) {
      console.log("user/create set user data #####");
      fc.users
        .doc(user.uid)
        .set({
          nameFirstEN: registerData.nameEN,
          nameLastEN: registerData.lastNameEN,
          nameFirstTH: registerData.nameTH,
          nameLastTH: registerData.lastNameTH,
          phone: registerData.phone,
          email: registerData.email,
          imageProfileUrl: "",
          imageProfilePath: "",
          pageLimit: 10,
        })
        .then(function () {
          router.push("/companies-list");
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    async addUserInCompany(context, { companyId, user, role }) {
      let companyUserObject = {};
      let userObject = {};
      for (const data in user) {
        if (data !== "id") {
          userObject[data] = user[data];
        }
      }

      companyUserObject = await getRoleList(companyUserObject, role);

      fc.companies
        .doc(companyId)
        .get()
        .then(function (companyData) {
          companyUserObject.companyID = companyData.id;
          companyUserObject.userID = user.id;
          companyUserObject.user = userObject;
          companyUserObject.company = companyData.data();

          fc.db
            .collection("CompaniesUsers")
            .doc(companyId + "_" + user.id)
            .set(companyUserObject)
            .then(function () {})
            .catch(function (error) {
              console.log(error);
            });
        })
        .catch(function (error) {
          console.log("Error getting document:", error);
        });
    },
    updatePageLimitSetting({ commit }, { userId, pageLimit }) {
      commit("setLoading", true);
      fc.users
        .doc(userId)
        .set({ pageLimit: pageLimit }, { merge: true })
        .then(function () {
          commit("setLoading", false);
          localStorage.setItem("pageLimit", pageLimit || 10);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    async updateRoleUser({ commit }, { user, role }) {
      commit("setLoading", true);
      let userObject = await getRoleList({}, role);

      fc.db
        .collection("CompaniesUsers")
        .doc(user.id)
        .set(userObject, { merge: true })
        .then(function () {
          commit("setLoading", false);
          commit("setUpdateDataStatus", "success");
        })
        .catch(function (error) {
          commit("setUpdateDataStatus", "error");
          console.log(error);
        });
    },
    updateUserProfile({ commit, dispatch }, { profile }) {
      commit("setLoading", true);
      commit("setUpdateProfileStatus", "loading");
      let currentUser = firebase.auth().currentUser;
      let profileUpload = { ...profile };

      delete profileUpload.imageProfileShow;
      if (
        profile.imageProfileUrl &&
        typeof profile.imageProfileUrl !== "string"
      ) {
        let timeStamp = new Date().getTime();
        let storageRef = firebase
          .storage()
          .ref(`Users/${currentUser.uid}/ProfileImages/${timeStamp}.jpg`);
        let uploadTask = storageRef.put(profile.imageProfileUrl);
        uploadTask.on(
          "state_changed",
          function progress(snapshot) {
            let percentage =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            commit("setUploadImgState", percentage);
          },
          function error(err) {
            console.log(err);
            commit("setUpdateProfileStatus", "error");
          },
          function () {
            uploadTask.then((snapshot) => {
              snapshot.ref.getDownloadURL().then(() => {
                let gsPath =
                  "gs://" + snapshot.ref.bucket + "/" + snapshot.ref.fullPath;
                axios
                  .get(fc.getImageUrl + gsPath)
                  .then(function (response) {
                    if (response && response.data && response.data.image_url) {
                      profileUpload.imageProfileUrl = response.data.image_url;
                      profileUpload.imageProfilePath = gsPath;
                      dispatch("updateUserDetail", {
                        profileUpload: profileUpload,
                        currentUser: currentUser,
                      });
                    }
                  })
                  .catch(function (error) {
                    console.log(error);
                  });
              });
            });
          }
        );
      } else {
        delete profileUpload.imageProfileUrl;
        delete profileUpload.imageProfilePath;
        dispatch("updateUserDetail", {
          profileUpload: profileUpload,
          currentUser: currentUser,
        });
      }
    },
    updateUser({ commit, dispatch }, { profile, changeEmail }) {
      if (changeEmail) {
        commit("setLoading", true);
        commit("setUpdateProfileStatus", "loading");
        let currentUser = firebase.auth().currentUser;
        let newEmail = profile["email"];
        return firebase
          .auth()
          .fetchSignInMethodsForEmail(newEmail)
          .then(function (signInMethods) {
            if (signInMethods.length > 0) {
              commit("setLoading", false);
              commit("setUpdateProfileStatus", "error");
              return "email is duplicate";
            } else {
              currentUser
                .updateEmail(newEmail)
                .then(function () {
                  commit("setLoading", false);
                  commit("setUpdateProfileStatus", "success");
                  dispatch("updateUserProfile", { profile });
                })
                .catch(function (error) {
                  commit("setProfileChangeEmail", {
                    profile: profile,
                    changeEmail: changeEmail,
                  });
                  commit("setPasswordDialog", true);
                  console.log(error);
                });
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      } else {
        dispatch("updateUserProfile", { profile });
      }
    },
    updateUserDetail({ commit }, { profileUpload, currentUser }) {
      let batch = fc.db.batch();
      let user = fc.db.collection("Users").doc(currentUser.uid);
      batch.update(user, profileUpload);
      batch
        .commit()
        .then(function () {
          commit("setLoading", false);
          commit("setUpdateProfileStatus", "success");
        })
        .catch(function (error) {
          console.log(error);
          commit("setLoading", false);
          commit("setUpdateProfileStatus", "error");
        })
        .finally(() =>{
          commit("setLoading", false);
          setInterval(() => {
            commit("setUpdateProfileStatus", "");
          }, 4000);
        })
        ;
    },
    checkPasswordAndResetPasswordUser(
      { commit },
      { oldPassword, newPassword }
    ) {
      commit("setLoading", true);
      let currentUser = firebase.auth().currentUser;
      firebase
        .auth()
        .signInWithEmailAndPassword(currentUser.email, oldPassword)
        .then(() => {
          currentUser
            .updatePassword(newPassword)
            .then(function () {
              commit("setChangePasswordStatus", "success");
            })
            .catch(function (error) {
              console.log(error);
              commit("setChangePasswordStatus", "error");
            });
        })
        .catch((error) => {
          console.log(error);
          if (error && error.code === "auth/wrong-password") {
            commit("setChangePasswordStatus", "authError");
          } else commit("setChangePasswordStatus", "error");
        });
      commit("setLoading", false);
    },
    removeCompanyUser(context, { userId }) {
      fc.db
        .collection("CompaniesUsers")
        .doc(userId)
        .delete()
        .then(function () {})
        .catch(function (error) {
          console.log(error);
        });
    },
    setSearchEmpty({ commit }) {
      commit("setUserSearch", null);
    },
    setUserProfile({ commit }, key, user) {
      commit("setUserProfile", key, user);
    },
    setChangePasswordStatus({ commit }, { status }) {
      commit("setChangePasswordStatus", status);
    },
    setProfileLoadingEmpty({ commit }) {
      commit("setLoading", false);
      commit("setUpdateProfileStatus", null);
      commit("setUploadImgState", null);
    },
    setUpdateDataStatusEmpty({ commit }) {
      commit("setUpdateDataStatus", null);
    },
    setPageLimitAutoChange({ commit }) {
      commit("setPageLimitAutoChange", !this.state.user.pageLimitAutoChange);
    },
  },
  modules: {},
};
